(function() {
  exports.Filter = (function() {
    function Filter() {}

    Filter.prototype.init = function(type, value, title, special, parent) {
      this.type = type;
      this.value = value;
      this.title = title;
      this.special = special;
      this.visible = false;
      this.active = true;
      this.selector = '';
      return this.parent = parent;
    };

    Filter.prototype.showSelf = function() {
      var sel, ths;
      ths = this;
      ths.visible = true;
      sel = '<span class="applied_filter" data-value="' + ths.value + '">' + ths.title;
      if (ths.type !== 'status_applied_filter' && ths.type !== 'type_applied_filter') {
        sel += '<i class="fa fa-remove pull-right"></i>';
      }
      sel += '<br></span>';
      ths.selector = $(sel);
      $('.' + ths.type).append(ths.selector);
      return ths.selector.children('i.fa fa-remove').bind('click', function() {
        return ths.destroySelf();
      });
    };

    Filter.prototype.destroySelf = function(removeFromArray) {
      var aimChevronRight, filter, i, len, ref, ths;
      if (removeFromArray == null) {
        removeFromArray = true;
      }
      ths = this;
      ths.selector.fadeOut();
      ths.selector.remove();
      if (removeFromArray) {
        ths.parent.filters.splice($.inArray(ths, ths.parent.filters), 1);
        ths.parent.updateFilters();
      }
      aimChevronRight = 1;
      ref = ths.parent.filters;
      for (i = 0, len = ref.length; i < len; i++) {
        filter = ref[i];
        if (filter.type === ths.type) {
          aimChevronRight = 0;
          break;
        }
      }
      if (aimChevronRight) {
        return $('.' + ths.type).children('i').removeClass('fa fa-chevron-down').addClass('fa fa-chevron-right');
      }
    };

    Filter.prototype.hideSelf = function() {
      var ths;
      ths = this;
      ths.selector.fadeOut();
      ths.active = false;
      return ths.visible = false;
    };

    Filter.prototype.revealSelf = function() {
      var ths;
      ths = this;
      ths.selector.fadeIn();
      ths.active = true;
      return ths.visible = true;
    };

    return Filter;

  })();

}).call(this);
